export const SERVICE_AREAS = [
  'Hawthorne, NY',
  'Armonk, NY',
  'Bedford, NY',
  'Bronxville, NY',
  'Chappaqua, NY',
  'Eastchester, NY',
  'Harrison, NY',
  'Irvington, NY',
  'Katonah, NY',
  'Larchmont, NY',
  'Mamaroneck, NY',
  'Mount Kisco, NY',
  'Mount Vernon, NY',
  'New Rochelle, NY',
  'Ossining, NY',
  'Peekskill, NY',
  'Pelham, NY',
  'Pleasantville, NY',
  'Port Chester, NY',
  'Rye, NY',
  'Scarsdale, NY',
  'Sleepy Hollow, NY',
  'Tarrytown, NY',
  'Tuckahoe, NY',
  'White Plains, NY',
  'Yonkers, NY',
  'Darien, CT',
  'Fairfield, CT',
  'Greenwich, CT',
  'Norwalk, CT',
  'Stamford, CT',
];

export const SCHEMA_AREA_SERVED = SERVICE_AREAS.map((name) => ({ '@type': 'City', name }));
